import { render } from "./productCRUD.vue?vue&type=template&id=520776eb&scoped=true"
import script from "./productCRUD.vue?vue&type=script&lang=js"
export * from "./productCRUD.vue?vue&type=script&lang=js"

import "./productCRUD.vue?vue&type=style&index=0&id=520776eb&scoped=true&lang=scss"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-520776eb"]])

export default __exports__